import * as THREE from 'three'

import BaseObject from './baseObject'
import MathsUtils from '@/utils/mathsUtils'


// Rectangle object
// Displays a filled / outlined rectangle
export default class RectObject extends BaseObject {
  constructor(editor, options = {}) {
    super(editor)

    this.persistable = false
    this.position = new THREE.Vector2(0, 0)
    this.scale = new THREE.Vector2(1, 1)
    this.width = options.width || 10
    this.height = options.height || 10
    this.filled = !!options.filled
    this.colour = options.colour || '#000000'
    this.opacity = parseFloat(options.opacity || 1.0)
    this.isCentered = options.isCentered !== undefined ? options.isCentered : true

    this.rectObj = null
    this.objectGeometry = null

    this.sceneObject = new THREE.Object3D()
    this.updateSceneObject()
  }

  /**
   * Dispose the object
   */
  dispose() {
    super.dispose()

    if(this.objectGeometry) {
      this.objectGeometry.dispose()
      this.objectGeometry = null
    }
    this.rectObj = null
  }

  // onBeforeRender
  // Called prior to rendering of the object
  onBeforeRender() {
    super.onBeforeRender()

    if(this.rectObj) {
      this.rectObj.position.set(this.position.x, this.position.y, 200)
      this.rectObj.scale.set(this.scale.x, this.scale.y, 1.0)
      this.rectObj.material.color.set(this.colour)
      this.rectObj.material.opacity = this.opacity
    }
  }


  // Update the position of the rectangle
  setPosition(pos) {
    this.position.set(pos.x, pos.y)
  }

  // Update the size of the rectangle
  // Rebuild the scene object
  setSize(width, height) {
    this.width = width
    this.height = height
    this.updateSceneObject()
  }


  /**
   * Build the scene object
   */
  updateSceneObject() {
    if(this.objectGeometry) {
      this.objectGeometry.dispose()
      this.objectGeometry = null
    }
    this.rectObj = null

    this.clearSceneObject()

    var halfWidth = this.width / 2
    var halfHeight = this.height / 2

    var left = -halfWidth
    var top = -halfHeight
    var right = halfWidth
    var bottom = halfHeight

    if(!this.isCentered) {
      left = 0
      top = 0
      right = this.width
      bottom = this.height
    }

    // Build rectangle to display the square
    // Set at 0,0. On render will move object position to the position of the rectangle center
    var vertices = []    

    if(!this.filled) {
      vertices.push(left, top, 0, right, top, 0)
      vertices.push(right, top, 0, right, bottom, 0)
      vertices.push(right, bottom, 0, left, bottom, 0)
      vertices.push(left, bottom, 0, left, top, 0)

      this.objectGeometry = new THREE.BufferGeometry();
      this.objectGeometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3))
      
      var outlineMaterial = new THREE.LineBasicMaterial({
        color: this.colour,
        transparent: true,
        opacity: this.opacity,
      })
      this.rectObj = new THREE.LineSegments(this.objectGeometry, outlineMaterial)
      this.rectObj.computeLineDistances()
      this.sceneObject.add(this.rectObj)

    } else {
      vertices.push(left, top, 0)
      vertices.push(right, top, 0)
      vertices.push(right, bottom, 0)

      vertices.push(left, top, 0)
      vertices.push(right, bottom, 0)
      vertices.push(left, bottom, 0)

      this.objectGeometry = new THREE.BufferGeometry();
      this.objectGeometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3))

      var solidMaterial = new THREE.MeshBasicMaterial({
        side: THREE.DoubleSide,
        color: this.colour,
        transparent: true,
        opacity: this.opacity,
      })
      this.rectObj = new THREE.Mesh(this.objectGeometry, solidMaterial)
      this.sceneObject.add(this.rectObj)
    }
  }


  /**
   * Check if a point is over the rect
   */
  isPointOverRect(point) {
    var halfWidth = this.width / 2 * this.scale.x
    var halfHeight = this.height / 2 * this.scale.y

    var left = -halfWidth
    var top = -halfHeight
    var right = halfWidth
    var bottom = halfHeight

    if(!this.isCentered) {
      left = 0
      top = 0
      right = this.width * this.scale.x
      bottom = this.height * this.scale.y
    }

    var testX = point.x - this.position.x
    var testY = point.y - this.position.y

    if(testX < left || testY < top)
      return false
    if(testX > right || testY > bottom)
      return false

    return true
  }



}
